
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/mcp-gateway",
      function () {
        return require("private-next-pages/sign/mcp-gateway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/mcp-gateway"])
      });
    }
  